import type { PromoProductModel } from '@/shared/generated'
import type { TFunction } from 'i18next'

import { toast } from 'sonner'

import Sentry from '@/shared/lib/sentry'
import { download } from '@/shared/tools/report'

import buildTableBlob from './buildTableBlob'

export function buildDownloadTableHandler(t: TFunction) {
	return async ({
		rows,
		name,
	}: {
		rows: PromoProductModel[]
		name: string
	}) => {
		try {
			const blob = await buildTableBlob(rows, t)
			download(blob, `${name}.xlsx`)
		} catch (error) {
			Sentry.captureException(error)
			toast.error((error as Error)?.message ?? t('fatal_error_title'), {
				id: 'promo',
				duration: 5000,
			})
		}
	}
}
